import { on } from "@ngrx/store";
import { NewTokenAction } from "./token.actions";

export const tokenReducer = [
  on(NewTokenAction, (state: any, action) => {
    return Object.assign({}, state, { token: action.token });
  }),
];
